import { Button, Divider } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "src/redux/store";

export default () => {
    const { formatMessage } = useIntl();
    const { keycloak } = useSelector((state) => state.keycloakReducer);

    return <div style={{ width: "200px", padding: "12px", display: "grid", gridTemplate: "auto / auto" }}>
        {keycloak.authenticated ?  (
            <>
                <div>
                    {formatMessage({ id: "menu_account" })}:&nbsp;
                    {keycloak.tokenParsed.preferred_username}
                </div>
                <Divider style={{ margin: "15px 0" }} />
                <Button type="primary" onClick={() => keycloak.logout()}>
                    {formatMessage({ id: "menu_logout" })}
                </Button>
            </>
        ) : (
            <Button type="primary" onClick={() => keycloak.login({
                locale: localStorage.getItem("locale")
            })}>
                {formatMessage({ id: "menu_login" })}
            </Button>
        )}
    </div>;
};